import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, steps, currentLanguage }) => {
  return (
    <div className="w-full mb-6 md:mb-8 lg:mb-10">
      <div className="flex items-center justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-border -z-10">
          <div
            className="h-full bg-primary transition-all duration-500"
            style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
          />
        </div>

        {steps?.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isPending = stepNumber > currentStep;

          return (
            <div
              key={stepNumber}
              className="flex flex-col items-center gap-2 md:gap-3 bg-background px-2 md:px-3"
            >
              <div
                className={`
                  w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center transition-all duration-300
                  ${isCompleted ? 'bg-primary text-primary-foreground shadow-warm' : ''}
                  ${isCurrent ? 'bg-primary text-primary-foreground shadow-warm-md ring-4 ring-primary/20' : ''}
                  ${isPending ? 'bg-muted text-muted-foreground' : ''}
                `}
              >
                {isCompleted ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <span className="text-sm md:text-base font-semibold">{stepNumber}</span>
                )}
              </div>
              <div className="text-center">
                <p
                  className={`
                    text-xs md:text-sm font-medium whitespace-nowrap
                    ${isCurrent ? 'text-foreground' : 'text-muted-foreground'}
                  `}
                >
                  {step?.[currentLanguage]}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;